import { mediaGQLFields } from '../media/media.fields.js';
import { spaceGQLFields } from './space.fields.js';
export const pageGqlFields = (fields = { space: 'default' }) => {
    return `
    seoDetail {
      additionalMeta {
        type
        properties {
          key
          value
        }
      }
      description
      jsonld
      title
      thumbnail {
        ${mediaGQLFields()}
      }
    }
    ${fields.space
        ? `space {
      ${spaceGQLFields(fields.space)}
    }`
        : ''}
  `;
};
//# sourceMappingURL=page.fields.js.map